import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const Service2 = () => {
    const sectionStyle = {
        padding: '25px 0',
        
    };

    const wrapperStyle = {
        padding: '20px 0'
    };

    const slideStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease'
    };

    const imageStyle = {
        maxWidth: '50%',
        height: 'auto',
        objectFit: 'contain',
        opacity: 1,
        transition: 'all 0.5s ease',
        cursor: 'pointer',
    };

    return (
        <>
            <div className="section-heading text-center mb-40">
                <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Technology Stack<span className="hl"> We Work On</span></h2>
            </div>
            <div style={sectionStyle}>
                <div className="container">
                    <div style={wrapperStyle}>
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={30}
                            slidesPerView={5}
                            loop={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 2,
                                },
                                576: {
                                    slidesPerView: 3,
                                },
                                768: {
                                    slidesPerView: 4,
                                },
                                992: {
                                    slidesPerView: 5,
                                },
                            }}
                        >
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l1.png" alt="Angular" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l2.png" alt="Ethereum" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l3.png" alt="React Native" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l4.png" alt="PostgreSQL" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l5.png" alt="Technology Logo 5" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l6.png" alt="Technology Logo 6" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l7.png" alt="Technology Logo 7" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l8.png" alt="Technology Logo 8" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l9.png" alt="Technology Logo 9" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l10.png" alt="Technology Logo 10" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l11.png" alt="Technology Logo 11" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/l12.png" alt="Technology Logo 12" />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Service2;
